import React from 'react';
import './Page404.css';

export const Page404 = () => {
  return (
    <div className="page-404-container">
      <div className="page-404-content">
        <h1>404</h1>
        <h3>Page not found</h3>
      </div>
    </div>
  );
};

export default Page404;
